<template>
  <div class="edit-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="电话机器人" name="first"></el-tab-pane>
      <el-tab-pane label="文字机器人" name="second"></el-tab-pane>
    </el-tabs>
    <el-tabs tab-position="left" v-model="currentTab">
      <el-tab-pane label="问法管理" name="question"
        ><my-qustion :activeName="activeName"></my-qustion
      ></el-tab-pane>
      <el-tab-pane label="回复管理" name="reply"
        ><my-reply :activeName="activeName"></my-reply
      ></el-tab-pane>
      <el-tab-pane label="异常管理" name="error"
        ><my-slot :activeName="activeName"></my-slot
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    components: {
      'my-qustion': () => import('./questionManager.vue'),
      'my-slot': () => import('./slotManager.vue'),
      'my-reply': () => import('./replyManager.vue'),
    },
    data() {
      return {
        activeName: 'second',
        currentTab: 'question',
      }
    },
    methods: {
      handleClick() {
        this.currentTab = 'question'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .edit-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .edit-header {
    }
    .edit-content {
      display: flex;
    }
    .edit-aside {
      display: flex;
      flex-direction: column;
    }
    .left-tab {
      padding: 0;
      padding-right: 20px;
    }
  }
  ::v-deep .el-tabs__nav-wrap::after {
    height: 0;
  }
  ::v-deep .el-tabs__item {
    padding: 0;
    padding-right: 20px;
    font-size: 16px;
  }
</style>
